// Copyright 2026 FlairCV Contributors
// SPDX-License-Identifier: AGPL-3.0-or-later

import { z } from 'zod';

/** Schema for creating/editing an accomplishment. */
export const accomplishmentSchema = z.object({
  experience_id: z.string().optional().or(z.literal('')),
  description: z
    .string()
    .min(1, 'Description is required.')
    .max(10000, 'Description must be at most 10,000 characters.'),
  impact: z
    .string()
    .max(2000, 'Impact must be at most 2,000 characters.')
    .optional()
    .or(z.literal('')),
  category: z
    .string()
    .max(100, 'Category must be at most 100 characters.')
    .optional()
    .or(z.literal('')),
  tags: z.string().optional().or(z.literal('')),
});

export type AccomplishmentFormData = z.infer<typeof accomplishmentSchema>;
